
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.405 5.028C9.317 5.007 9.211 5 8.675 5H8.6c-.997 0-1.684 0-2.217.044-.522.043-.808.122-1.018.229a2.5 2.5 0 00-1.093 1.092c-.106.21-.185.496-.228 1.018C4.001 7.916 4 8.603 4 9.6v7.8c0 .997 0 1.684.044 2.218.043.521.122.807.228 1.017a2.5 2.5 0 001.093 1.093c.21.107.496.185 1.018.228.533.043 1.22.044 2.217.044h10.8c.997 0 1.684 0 2.217-.044.522-.043.808-.121 1.018-.228a2.5 2.5 0 001.092-1.093c.107-.21.186-.496.229-1.018.043-.533.044-1.22.044-2.217v-4.8c0-.996 0-1.684-.044-2.217-.043-.522-.122-.808-.229-1.018a2.5 2.5 0 00-1.092-1.092c-.21-.107-.496-.186-1.018-.229C21.084 8.001 20.397 8 19.4 8H14.242c-.407 0-.766 0-1.114-.083a3 3 0 01-.867-.359c-.306-.187-.559-.441-.846-.73l-.06-.058-1.125-1.126c-.38-.38-.458-.45-.536-.497a1 1 0 00-.289-.12zM8.758 3c.407 0 .765 0 1.114.083a3 3 0 01.867.36c.306.186.559.44.846.728l.06.06 1.125 1.125c.38.38.459.45.536.497a1 1 0 00.289.12c.088.02.194.027.73.027h5.117c.945 0 1.714 0 2.338.051.646.053 1.224.165 1.763.44a4.5 4.5 0 011.966 1.966c.275.539.387 1.117.44 1.763.051.624.051 1.394.051 2.338v4.884c0 .945 0 1.714-.051 2.338-.053.646-.165 1.224-.44 1.763a4.5 4.5 0 01-1.966 1.967c-.539.274-1.117.386-1.763.44-.624.05-1.393.05-2.338.05H8.558c-.944 0-1.714 0-2.338-.05-.646-.054-1.224-.166-1.763-.44a4.5 4.5 0 01-1.967-1.967c-.274-.539-.386-1.117-.439-1.763C2 19.156 2 18.387 2 17.442V9.558c0-.944 0-1.714.051-2.338.053-.646.165-1.224.44-1.763a4.5 4.5 0 011.966-1.966c.539-.275 1.117-.387 1.763-.44.624-.05 1.394-.05 2.338-.05h.117L8.758 3z","fill":"currentColor"}})])
          )
        }
      }
    